export const mergeClasses = (inlineArray, propArray) => {
  if (!propArray || propArray.length === 0) return inlineArray;
  if (!Array.isArray(propArray)) {
    console.warn("Passing a non-array to mergeClasses");
    return inlineArray;
  }
  return inlineArray.concat(
    propArray.filter((item) => inlineArray.indexOf(item) < 0)
  );
};

export const getCookie = (key) => {
  if (!key) {
    return null;
  }
  return (
    decodeURIComponent(
      document.cookie.replace(
        new RegExp(
          "(?:(?:^|.*;)\\s*" +
            encodeURIComponent(key).replace(/[-.+*]/g, "\\$&") +
            "\\s*\\=\\s*([^;]*).*$)|^.*$"
        ),
        "$1"
      )
    ) || null
  );
};

export const removeBodyOverflowHidden = () => {
  const body = document.body;
  if (body.style.overflow === "hidden") {
    body.style.overflow = ""; // Reset the overflow style
  }
};

export const setCookie = (key, value, end, path, domain, secure, maxAge) => {
  if (!key || /^(?:expires|max-age|path|domain|secure)$/i.test(key)) {
    return false;
  }
  let expires = "";
  if (end) {
    switch (end.constructor) {
      case Number:
        expires =
          end === Infinity
            ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT"
            : "; expires=" + new Date(end * 1e3 + Date.now()).toUTCString();
        break;
      case String:
        expires = "; expires=" + end;
        break;
      case Date:
        expires = "; expires=" + end.toUTCString();
        break;
      default:
        expires = "";
    }
  }
  document.cookie =
    encodeURIComponent(key) +
    "=" +
    encodeURIComponent(value) +
    expires +
    (domain ? "; domain=" + domain : "") +
    (maxAge ? "; max-age=" + maxAge : "") +
    (path ? "; path=" + path : "") +
    (secure ? "; secure" : "");
  return true;
};

export const removeCookie = (key, path, domain) => {
  if (!hasCookie(key)) {
    return false;
  }
  document.cookie =
    encodeURIComponent(key) +
    "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" +
    (domain ? "; domain=" + domain : "") +
    (path ? "; path=" + path : "");
  return true;
};

export const hasCookie = (key) => {
  if (!key || /^(?:expires|max-age|path|domain|secure)$/i.test(key)) {
    return false;
  }
  return new RegExp(
    "(?:^|;\\s*)" +
      encodeURIComponent(key).replace(/[-.+*]/g, "\\$&") +
      "\\s*\\="
  ).test(document.cookie);
};

export const debounce = (func, delay) => {
  let debounceTimer;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
};
